import { createApp } from 'vue';
import YoutubeBlock from './YoutubeBlock.vue';
import YoutubePlaylistBlock from './YoutubePlaylistBlock.vue';
const youtubeBlockDivs = document.querySelectorAll('.YoutubeBlockApp');
const youtubePlaylistBlockDivs = document.querySelectorAll(
    '.YoutubePlaylistBlockApp'
);
if (youtubeBlockDivs) {
    // Initialize all youtube blocks
    youtubeBlockDivs.forEach(function (youtubeblockDiv) {
        const app = createApp(YoutubeBlock, {
            blockId: youtubeblockDiv.getAttribute('data-blockid'),
            horizontalPreview: youtubeblockDiv.getAttribute(
                'data-horizontalpreview'
            ),
            simplePreview: youtubeblockDiv.getAttribute('data-simplepreview'),
        });
        app.mount(youtubeblockDiv);
    });
}

if (youtubePlaylistBlockDivs) {
    // Initialize all youtube playlist blocks
    youtubePlaylistBlockDivs.forEach(function (youtubeblockDiv) {
        const app = createApp(YoutubePlaylistBlock, {
            blockId: youtubeblockDiv.getAttribute('data-blockid'),
            horizontalPreview: youtubeblockDiv.getAttribute(
                'data-horizontalpreview'
            ),
            simplePreview: youtubeblockDiv.getAttribute('data-simplepreview'),
        });
        app.mount(youtubeblockDiv);
    });
}
